//Running game for Arena

var FiveRollGame = require('BaseFiveRollGame.js');
var fiveRollGame = new FiveRollGame(null, window.devicePixelRatio);



//////////////////
// WEBPACK FOOTER
// ./src/scripts/ArenaFiveRollGame.js
// module id = 0
// module chunks = 0